<!-- 资讯素材 -->
<template>
	<div class="wrap">
		<div class="rightsidebar">
			<ul class="list">
				<li v-for="(item, index) in list" :key="index">
					<a href="javascript:void(0)">
						<img :src="item.cover" class="img">
						<div class="bottom">
							<span class="name">{{item.title}}</span>
							<!-- <button type="button" class="btn" @click="showModal">
								<img src="../../assets/icon-9.png">分享
							</button> -->
							<a :href="item.cover" target="_bank" type="button" class="btn">
								<img src="../../assets/share-2.png">下载
							</a>
						</div>
					</a>
				</li>
				<!-- 无内容时显示 -->
				<div class="normal-box" v-if="list.length == 0">
					<img src="../../assets/normal-1.png">
					暂无数据
				</div>
			</ul>
		</div>

		<div v-show="isShowModal">
			<div class="mask-layer" @click="closeModal"></div>
			<div class="window">
				<p class="window-label">分享到</p>
				<div class="window-bottom">
					<div class="window-content">
						<button type="button">
							<img src="../../assets/share-1.png">微信
						</button>
						<button type="button">
							<img src="../../assets/share-2.png">保存相册
						</button>
					</div>
					<div class="window-btn-box">
						<button type="button">分享</button>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import Header from '../../components/header.vue';
	import Footer from '../../components/footer.vue';
	import { informationGetNewsMaterial } from '../../service/service';
import { listenerScrollToBottom } from '../../utils/util';
	export default {
		components: {
			Header,
			Footer
		},
		data() {
			return {
				//选项卡
				isActive: 0,
				navList: [{
					index: 0,
					title: '线上素材',
				}, {
					index: 1,
					title: "线下素材",
				}],
				//弹窗
				isShowModal: false,
				
				list: [],
				page: 1,
				page_num: 20,
			};
		},
		mounted() {
			this.getList();
			// 监听滚动到底部
			listenerScrollToBottom(() => this.getList());
		},
		methods: {

			// 获取列表
			getList() {
				const {
					page,
					page_num,
					isActive,
				} = this;
				const params = {
					page,
					page_num,
					// 类型（1线上，2线下）
					type: isActive + 1,
				};
				informationGetNewsMaterial(params).then(res => {
					if (res.code === 1) {
						const list = res.data.list;
						this.list = page > 1 ? [...this.list, ...list] : list;
						if (list.length === 0) {
							this.$message.info('没有更多数据了');
						} else {
							this.page = this.page + 1;
						}
					} else {
						this.$message.error(msg);
					}
				})
			},

			//弹窗
			showModal() {
				this.isShowModal = true
			},
			closeModal() {
				this.isShowModal = false
			}
		}
	}
</script>

<style scoped>
	.wrap {
		width: 100%;
		margin: 0 !important;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}

	.top {
		width: 1200px;
		height: 76px;
		line-height: 76px;
		background-color: #FFFFFF;
		border-radius: 8px;
		display: flex;
		align-items: center;
		padding: 0 19px;
		box-sizing: border-box;
		color: #484848;
		font-size: 20px;
		margin: 20px 0;
	}

	.top-icon {
		width: 10px;
		margin: 0 10px;
	}

	.top-name {
		color: #F2501A;
	}

	.container {
		width: 1200px;
		display: flex;
		align-items: flex-start;
		margin-bottom: 43px;
	}

	.leftsidebar {
		width: 144px;
		padding: 21px 0 28px;
		display: flex;
		flex-direction: column;
		background-color: #FFFFFF;
		border-radius: 8px;
		margin-right: 19px;
	}

	.leftsidebar>a {
		width: 100%;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		margin-bottom: 20px;
		padding: 0 0 0 29px;
		box-sizing: border-box;
		color: #000000;
		font-size: 16px;
		position: relative;
	}

	.leftsidebar>a.active {
		color: #F2501A;
		font-size: 18px;
	}

	.leftsidebar>a.active::after {
		content: "";
		position: absolute;
		left: 0;
		top: 50%;
		transform: translate(0, -50%);
		width: 4px;
		height: 26px;
		background: url(../../assets/border.png) no-repeat;
		background-size: 100% 100%;
	}

	.sanjiao {
		width: 14px;
		margin-left: 10px;
	}

	.rightsidebar {
		width: calc(100% - 0px);
		display: flex;
		flex-direction: column;
	}

	.list {
		width: 100%;
		display: flex;
		flex-wrap: wrap;
	}

	.list>li {
		width: 19.2%;
		margin-right: 1%;
		margin-bottom: 1%;
	}

	.list>li:nth-child(5n) {
		margin-right: 0;
	}

	.list>li>a {
		width: 100%;
		display: flex;
		flex-direction: column;
		background-color: #FFFFFF;
		border-radius: 8px;
		padding: 9px 9px 0;
		box-sizing: border-box;
	}

	.img {
		width: 100%;
		height: 166px;
		border-radius: 8px;
		object-fit: cover;
	}

	.bottom {
		width: 100%;
		height: 42px;
		line-height: 42px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.name {
		width: calc(100% - 60px);
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		color: #202020;
		font-size: 16px;
	}

	.btn {
		width: 57px;
		height: 23px;
		line-height: 23px;
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: #F2501A;
		color: #FFFFFF;
		font-size: 12px;
		border-radius: 50px;
	}

	.btn>img {
		width: 12px;
		margin-right: 3px;
	}

	.normal-box {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		color: #999999;
		font-size: 13px;
		padding: 270px 0;
	}

	.normal-box>img {
		width: 290px;
		margin-bottom: 7px;
	}

	.mask-layer {
		width: 100%;
		height: 100vh;
		position: fixed;
		background: rgba(0, 0, 0, 0.38);
		top: 0;
		left: 0;
		z-index: 99999;
	}

	.window {
		width: 600px;
		height: 572px;
		position: fixed;
		background: #FFFFFF;
		border-radius: 8px;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		z-index: 999999;
	}

	.window-label {
		width: 100%;
		height: 148px;
		line-height: 148px;
		border-bottom: 1px solid #E0E0E0;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 36px;
		color: #333333;
	}

	.window-bottom {
		width: 100%;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		height: calc(100% - 148px);
		padding: 67px 0 47px;
		box-sizing: border-box;
	}

	.window-content {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0 132px;
		box-sizing: border-box;
	}

	.window-content button {
		display: flex;
		flex-direction: column;
		align-items: center;
		color: #202020;
		font-size: 16px;
	}

	.window-content button img {
		width: 90px;
		height: 90px;
		margin-bottom: 12px;
	}

	.window-btn-box {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.window-btn-box button {
		width: 351px;
		height: 95px;
		line-height: 95px;
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: #F2501A;
		border-radius: 20px;
		font-size: 37px;
		color: #FFFFFF;
	}
	.normal-box {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		color: #999999;
		font-size: 13px;
		padding: 100px 0;
	}
	
	.normal-box>img {
		width: 40%;
		margin-bottom: 6px;
	}
</style>
